import { render, staticRenderFns } from "./PublishPreviewTable.vue?vue&type=template&id=0a2036db&scoped=true"
import script from "./PublishPreviewTable.vue?vue&type=script&lang=js"
export * from "./PublishPreviewTable.vue?vue&type=script&lang=js"
import style0 from "./PublishPreviewTable.vue?vue&type=style&index=0&id=0a2036db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2036db",
  null
  
)

export default component.exports